
interface Item {
	icon?: JSX.Element;
	text?: string;
	onClick: React.MouseEventHandler;
}

export default function ContextItem(props: Item) {
	return (
		<li
			style={{ overflow: "hidden" }}
			className="flex cursor-pointer items-center gap-3 whitespace-nowrap px-3 py-2 hover:bg-gray-100 rounded w-full max-w-md"
			onClick={props.onClick}
		>
			{props.icon}
			{props.text}
		</li>
	);
}
